export default __webpack_public_path__ + "static/media/weight.b26c1e3d.png";